import { render, staticRenderFns } from "./Bindmobile.vue?vue&type=template&id=c8da6034&scoped=true&"
import script from "./Bindmobile.vue?vue&type=script&lang=js&"
export * from "./Bindmobile.vue?vue&type=script&lang=js&"
import style0 from "./Bindmobile.vue?vue&type=style&index=0&id=c8da6034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8da6034",
  null
  
)

export default component.exports